import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import apolloClient from '../../apollo';
import App from './App';
import LoadingScreen from './Common/LoadingScreen';
import { store } from './store';
import ToastContainer from './Toasts/ToastContainer';

export default function Router() {
  return (
    <Provider store={store}>
      <RouterBody />
    </Provider>
  );
}

function RouterBody() {
  return (
    <React.Suspense fallback={<LoadingScreen />}>
      <ApolloProvider client={apolloClient()}>
        <ToastContainer />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProvider>
    </React.Suspense>
  );
}
